<template>
    <div>
        <template v-if="residueSize>=totalSize && totalSize>0">
            <el-dialog
                    title="打包下载" class="fotoo"
                    :visible.sync="dialogVisible"
                    width="50%" append-to-body
                    :before-close="handleClose">
                <div class="font-size14 gray-font"
                        style="padding: 0 60px 12px; margin-top: -5px; box-sizing: border-box; border-bottom: 1px solid #E0E0E0;position: relative;">
                    单次打包不超过{{oneMaxSize}}G
                    <div class="downall-tips-view">
                        <div class="downall-tips">打包人数较多时，预计最长1小时左右，急需下载请使用批量下载！</div>
                        <div class="downall-tips-message">
                            <i class="el-icon-message-solid"></i>
                        </div>
                    </div>
                </div>
                <div style="padding: 20px 60px; cursor: pointer;">
                    <el-card class="down-box-card">
                        <el-form label-width="120px">
                            <el-form-item label="已选文件大小：">
                                共计 {{MG(totalSize)}}
                            </el-form-item>
                            <el-form-item label="剩余下载额度大小：">
                                剩余 {{MG(residueSize)}}
                            </el-form-item>
                        </el-form>
                    </el-card>
                    <div style="padding: 40px 0;font-weight: 500;" class="font-size20">

                        <el-col :span="4">文件夹：</el-col>
                        <el-col :span="20">
                            <el-radio-group v-model="isFolder">
                                <el-radio :label="1" style="transform:scale(1.5);">以“每次投稿”为文件夹</el-radio>
                                <el-radio :label="0" style="transform:scale(1.5);margin-left: 80px;">不分文件夹</el-radio>
                            </el-radio-group>
                        </el-col>
                    </div>
                    <el-divider></el-divider>
                    <div style="padding-bottom: 18px;font-weight: 500;" class="font-size20">
                        指定文件命名 (点击下方选择)
                    </div>
                    <div>
                        <el-tag v-for="item in tags" v-bind:key="tags" type="info" @click="checkItem(item)"
                                style="margin-right: 10px; margin-top: 10px;">{{item.name}}
                        </el-tag>
                    </div>
                    <div v-if="rename.length>0" class="green-font">
                        <template v-for="(item,index) in rename">
                            <el-tag size="mini" closable type="success"
                                    style="margin-top: 15px;" @close="removeRename(index)"
                            >{{item.name}}
                            </el-tag>
                            {{index + 1 == rename.length ? '' : '-'}}
                        </template>

                    </div>
                    <el-divider></el-divider>
                </div>

                <div class="flex-cm" style="padding-bottom: 40px">
                    <!--
                    <div class="button source" @click="down('compress')">
                        下载压缩文件
                        <div class="source-tip">省下载额度</div>
                    </div>
                    -->
                    <div class="button" @click="down('source')">开始打包</div>
                </div>
            </el-dialog>
        </template>
        <template v-else="">
            <el-dialog
                    title="打包下载" class="fotoo"
                    :visible.sync="dialogVisible"
                    width="50%" append-to-body
                    :before-close="handleClose">
                <div class="text-center">
                    已选共计 {{MG(totalSize)}}
                    <br>当前剩余下载额度{{MG(residueSize)}}，下载额度不足请充值
                </div>
                <div class="text-center margin-tb-xl">
                    <a href="https://support.qq.com/products/57964/faqs/106896"
                       style="color: #576B95;"
                       target="_blank">如何获取免费下载额度</a>
                </div>
                <div class="flex-cm" style="padding-bottom: 40px;margin-top: 40px;" @click="dialogVisible = false">
                    <a :href="buyVipUrl" target="_blank">
                        <div class="button source" style="width: 240px;">
                            升级版本，提升下载额度
                            <div class="source-tip">下载额度100G</div>
                        </div>
                    </a>
                    <router-link :to="'/checkout/buyTraffic?activityId='+draftinfo.activityId+'&activityName='+draftinfo.activityName+'&size='+(totalSize-residueSize)+'&userId='+draftinfo.createBy">
                        <div class="button">直接充下载额度</div>
                    </router-link>
                </div>
            </el-dialog>
        </template>

        <el-dialog
                title="微信扫一扫，订阅通知" class="fotoo"
                :visible.sync="dialogVisibleDownhis"
                width="50%" append-to-body
                :before-close="handleClose">
            <div>
                <el-tabs v-model="activeNameDownhis" @tab-click="handleClick">
                    <el-tab-pane label="订阅通知" name="wechat">
                        <div class="block" style="text-align: center;">
                            <el-image :src="codeurl">
                                <div slot="placeholder" class="image-slot">
                                    加载中<span class="dot">...</span>
                                </div>
                            </el-image>
                            <div class="demonstration red-font" style="margin-top: 20px;">打包完成后在去"下载记录"复制链接</div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-dialog>
    </div>
</template>
<script>
  import App from '../../util/comfun'
  import ElAlert from "../../../node_modules/element-ui/packages/alert/src/main.vue";
  import ElButton from "../../../node_modules/element-ui/packages/button/src/button.vue";

  const M = 1024 * 1024
  const G = M * 1024
  const oneMaxSize = 99999 //G
  export default {
    components: {
      ElButton,
      ElAlert
    },
    props: {
      residueSize: {//剩余下载额度
        type: Number,
        value: 0
      },
      draftinfo: {
        type: Object,
        value: {},
      }
    },

    data() {
      return {
        oneMaxSize:oneMaxSize,
        dialogVisible: false,
        activeName: 'self',
        M: M,
        totalSize: 0,
        isFolder: 1,
        //自定义收集项    customInfo
        tags: [
          {key: 'serialNumber', name: '投稿编号',},
          {key: 'submissionCreateTime', name: '投稿时间',},
        ],
        rename: [],

        dialogVisibleDownhis: false,
        activeNameDownhis: 'wechat',
        codeurl: '',
        buyVipUrl:'',
      }
    },
    methods: {
      MG: App.MG,
      handleClick() {
      },
      handleClose(done) {
        done();
      },
      /**
       * @param res
       * params
       */
      async show(res) {
        if(!this.hasConfirmGo){
          let hasRunning = await this.queryHasRunning(res.params)
          if (hasRunning) {
            let html = `
<div class="flex-lm" style="align-content: flex-start">
    <div style="font-size:34px;color:#FFA200; margin-left:10px;margin-right: 20px;"><i class="el-icon-warning"></i></div>
    <div style="padding-top: 20px;">
<div style="font-size: 16px;color: #5d5d5d;">已有任务正在打包中，打包开始后无法取消，并会扣除下载额度，是否继续打包？</div>
    </div>
</div>
`
            this.$confirm(html, {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确定打包',
              confirmButtonClass: 'button-bg-green',
              cancelButtonText: '查看打包任务',
              cancelButtonClass: 'button-line-green',
            }).then(()=>{
              this.hasConfirmGo=true
              this.show(res)
            }).catch(() => {
              this.$router.push({path: '/home/downhis'})
            });
            return;
          }
        }
        this.hasConfirmGo=false
        this.totalSize = 0
        await this.queryTotalSize(res.params)
        if (this.totalSize > this.oneMaxSize * G) {
          let html = `
<div class="flex-lm" style="align-content: flex-start">
    <div style="font-size:34px;color:#FFA200; margin-left:10px;margin-right: 20px;"><i class="el-icon-warning"></i></div>
    <div style="padding-top: 20px;">
<div style="font-size: 16px;color: #5d5d5d;">单次打包下载不能超过${this.oneMaxSize}G，请减少后重试！</div>
<div style="font-size: 14px;color: #999999;">超过${oneMaxSize}G的文件请分批打包</div>
    </div>
</div>
`
          this.$alert(html, {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '知道了',
            confirmButtonClass: 'button-bg-green',
          });
          return;
        }
        //this.setTags()
        if(this.residueSize>=this.totalSize && this.totalSize>0){
          //新开页面去下载
          App.packDown={
            activityId:this.draftinfo.activityId,
            residueSize:this.residueSize,
            totalSize:this.totalSize,
            res:res
          }
          App.cache('packDown',JSON.stringify(App.packDown))
          return this.$router.push({ path: '/checkout/packDown'})
        }
        this.dialogVisible = true
      },
      showTotalSize(totalSize){//剩余下载额度不足，直接显示
        this.totalSize=totalSize
        this.dialogVisible = true
      },
      removeRename(index) {
        this.rename.splice(index, 1)
      },
      checkItem(item) {
        let flag = true
        this.rename.some(it => {
          if (it.key == item.key) {
            flag = false;
            return true
          }
        })
        if (flag) {
          this.rename.push(item)
        }
      },
      setTags() {
        this.tags = [
          {key: 'serialNumber', name: '投稿编号',},
          {key: 'submissionCreateTime', name: '投稿时间',},
          //{key:'wardingName', name:'相册名称',},
          {key: 'originFileName', name: '原始文件名',},
        ]
        if (this.draftinfo.activityAuth.isTrack == 1) {
          this.tags.push({key: 'trackName', name: this.draftinfo.activityAuth.trackName||'分组或赛道',})
        }
        if (this.draftinfo.activityAuth.isTag == 1) {
          this.tags.push({key: 'tagName', name: this.draftinfo.activityAuth.tagName||'征稿单元',})
        }
        if (this.draftinfo.activityAuth.isContact == 1) {
          if (this.draftinfo.activityAuth.isMobile == 1) {
            this.tags.push({key: 'contactInfo', name: '手机号',})
          }
        }
        if (this.draftinfo.activityAuth.isSubmissionTips == 1) {
          if (this.draftinfo.activityAuth.isAuthorName == 1) {
            this.tags.push({key: 'autograph', name: '作者署名',})
          }
          if (this.draftinfo.activityAuth.isSubmissionName == 1) {
            this.tags.push({key: 'submissionName', name: '作品名称',})
          }
        }
        if (this.draftinfo.customFormInfo.isEnable == 1) {
          this.draftinfo.customFormInfo.inputList.forEach(item => {
            this.tags.push({key: item.id, name: item.name, type: 'customInfo'})
          })
        }
      },
      async queryTotalSize(query) {
        this.params = JSON.parse(JSON.stringify(query))
        if (this.params.materialType) {
          this.params.activityMaterialType = this.params.materialType
          delete this.params.materialType
        }
        this.params.wardingResultId = this.params.wardingId
        delete this.params.currentPage
        delete this.params.pageIndex
        delete this.params.orderOption
        delete this.params.pageSize
        console.log('queryTotalSize', this.params)
        let res = await App.demand('/download/queryTotalSize', 'POST', this.params)
        this.totalSize = res.data / 1
      },
      async queryHasRunning(query) {
        let flag = false
        let res = await App.demand('/download/record/queryList', 'POST', {
          "activityId": query.activityId,
          "pageIndex": 1,
          "pageSize": 5,
        })
        if (res.code == 200 && res.data.recordList) {
          res.data.recordList.forEach(r => {
            if (r.status == 1) {
              flag = true
              return true
            }
          })
        }
        return flag
      },
      down(type) {
        console.log('down', type)
        if(this.userDownloading) return this.$message({
          showClose: true,
          message: '正在提交，稍等片刻'
        });
        //this.dialogVisible=false
        //this.$emit('down',{type:type})
        if (this.residueSize < 1) {
          return this.$message({
            showClose: true,
            message: '剩余下载额度已欠费，请充值'
          });
        }
        if (this.rename.length < 1) {
          return this.$message({
            showClose: true,
            message: '必须指定文件命名'
          });
        }
        let params = JSON.parse(JSON.stringify(this.params))
        params.isFolder = this.isFolder ? 1 : 0
        params.inputIdList = []
        params.fileNameList = []
        this.rename.forEach(item => {
          if (item.type == 'customInfo') {
            params.inputIdList.push(item.key)
            params.formId = this.draftinfo.customFormInfo.id
          } else {
            params.fileNameList.push(item.key)
          }
        })
        if (params.inputIdList.length > 0) {
          params.fileNameList.push('customInfo')
        }
        params.wardingResultId=params.wardingId||''
        if (params.materialType) {
          params.activityMaterialType = params.materialType
          delete params.materialType
        }
        this.userDownloading=true
        App.demand('/download/userDownload', 'POST', params).then(res => {
          setTimeout(()=>{this.userDownloading=false},0)
          if (res.code != 200) {
            return this.$message({
              showClose: true,
              message: res.message,
            });
          }
          //this.diaplayQrcode()
          this.$router.push({ path: '/home/downhis'})
        })
      },
      pay() {
        this.$router.push({
          path: '/pay'
        })
      },
      async diaplayQrcode() {
        this.dialogVisible = false
        this.dialogVisibleDownhis = true;
        let param = JSON.stringify({
          gotopath: '/person/pages/subscribe',
          message: '打包完成后提醒我',
          activityId: this.draftinfo.activityId,
          subscribeType: 6,
        })
        let res = await App.demand('/activity/wechatapplet/saveParam', 'GET', {
          param: param,
        });
        this.codeurl = await App.System.Qrcode({
          autoColor: false,
          inHyaline: false,
          lineColor: '0,0,0',
          page: 'pages/enter/enter',
          scene: res.data,
          width: 430
        }, 'URL')
      },

    },
    mounted() {
      this.buyVipUrl=App.buyVipUrl(this.draftinfo.createBy)
    },

  }
</script>

<style>
    .simple {

    }

    .tips {
        padding-left: 60px;
        height: 25px;
        opacity: 1;
        font-size: 14px;
        font-family: PingFang, PingFang-SC;
        font-weight: SC;
        text-align: left;
        color: #999999;
        line-height: 25px;
        padding-bottom: 12px;
        border-bottom: 1px solid #e0e0e0;
    }

    .residueSize {
        font-size: 20px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #5d5d5d;
        line-height: 30px;
        margin-top: 24px;
        margin-bottom: 24px;
    }

    .button {
        width: 200px;
        height: 60px;
        opacity: 1;
        background: #3dc4a7;
        border-radius: 30px;

        opacity: 1;
        font-size: 18px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #ffffff;
        line-height: 60px;
        text-align: center;
        box-sizing: border-box;
        cursor: pointer;
    }

    .source {
        margin-right: 70px;
        position: relative;
    }

    .source-tip {
        position: absolute;
        top: -15px;
        left: 152px;
        min-width: 54px;
        height: 22px;
        opacity: 1;
        background: #ed7b61;
        border-radius: 11px;
        font-size: 12px;
        color: #fefefe;
        display: flex;
        align-items: center;
        text-align: center;
        justify-items: center;
        padding-left: 8px;
        padding-right: 8px;
        box-sizing: border-box;
        white-space: nowrap;
    }

    .source-tip::before {
        position: absolute;
        content: "";
        top: 10px;
        left: 0px;
        border-color: transparent transparent transparent #ED7B61;
        border-width: 10px;
        border-radius: 5px;
        border-style: solid;
    }

    .pfotoo.el-steps--simple {
        padding-left: 40px;
        padding-right: 40px;
    }

    .pfotoo .el-step.is-simple .el-step__head {
        display: none;
    }

    .pfotoo .el-step.is-simple:not(:last-of-type) .el-step__title {
        max-width: calc(100% - 20px);
    }

    .button-bg-green {
        width: 90px;
        height: 35px;
        background: #3dc4a7;
        border-radius: 5px;
    }

    .button-line-green {
        width: 90px;
        height: 35px;
        border: 1px solid #3dc4a7;
        border-radius: 5px;
        color: #3dc4a7;
    }
    .downall-tips-view{
        position: absolute;
        font-size: 14px;
        border-radius: 10px 10px 0 10px;
        overflow: hidden;
        width: 456px;
        height: 40px;
        top:-40px;
        left:calc(50% - 226px);
    }
    .downall-tips{
        width: 456px;
        height: 40px;
        background: #facebe;
        border-radius: 0px 28px 0px 10px;
        position: absolute;
        left:calc(50% - 226px);
        top:0px;
        content: "";
        color: #FE7157;
        font-size: 14px;
        line-height: 40px;
        text-indent: 40px;
    }
    .downall-tips::after{
        width: 42px;
        height: 38px;
        position: absolute;
        left:0;
        top:0px;
        content: "";
        color: #fefefe;
        font-size: 16px;
        line-height: 40px;
        text-align: center;
        box-sizing: border-box;
        border-top: 40px solid #FE6E5B;
        border-right: 10px solid transparent;
    }
    .downall-tips-message{
        width: 42px;
        height: 38px;
        position: absolute;
        left:calc(50% - 226px);
        top:0px;
        content: "";
        color: #fefefe;
        font-size: 16px;
        line-height: 40px;
        text-indent: 5px;
        text-align: left;
    }
    .down-box-card .el-card__body{
        padding: 10px;
    }
    .down-box-card .el-form-item{
        margin-bottom: 0px;
    }
</style>


// WEBPACK FOOTER //
// src/components/dialog/downAll.vue